// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-submenu-enter-active[data-v-f5814166],\n.show-submenu-leave-active[data-v-f5814166] {\n  transition: all 5s ease;\n}\n.show-submenu-enter[data-v-f5814166],\n.show-submenu-leave-to[data-v-f5814166] {\n  opacity: 0;\n  visibility: visible;\n}\n", ""]);
// Exports
module.exports = exports;
